var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-base-modal"},[_c('div',{staticClass:"c-base-modal__wrapper"},[_c('button',{staticClass:"c-base-modal__close",attrs:{"type":"button"},on:{"click":_vm.close}},[_c('base-icon',{attrs:{"width":"26","height":"26","name":"painel/close-icon"}})],1),_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }